import { floor } from 'lodash';
import { BC_TYPE, STEPCODE } from '../constant';
import { returnSharedFields } from './shared-fields';

export const detailsWorkflowFields = ({
  t,
  isBatch,
  isAudit,
  portion,
  stepCode,
  categoryOptions = [],
  subCategoryOptions = [],
  concreteOptions,
  blockOptions,
  floorOptions,
  unitOptions,
  supplierOptions,
  setSelectedRegion = () => {},
  setSelectedFloor = () => {},
  setSelectedRoom = () => {},
  selectedRegion,
  selectedFloor,
  selectedRoom,
  rsCompanyOptions,
  disposed,
  setValue,
  project
  // reset
}) => {
  const {
    cate,
    concreteGrade,
    serialNo,
    manuDate,
    rsCompany,
    rsinspectionDate,
    castingDate,
    deliveryDate,
    batchNo,
    arrivalDate,
    installDate,
    block,
    floorNo,
    unit,
    preview,
    roomInput,
    subCate,
    hingeSupplier,
    chipFailureSA,
    chipFailureSI,
    licensePlateNo,
    GpsDeviceId,
    secondCastingDate,
    productNo,
    dispose,
    asn,
    isCompleted,
    internalFinishDate,
    waterproofingInstallationDate,
    workingNo,
    remark
  } = returnSharedFields(t, portion);

  const pwraDateTime = (field) => (project?.ProjCode === 'PWRA' ? { ...field, type: 'dateTimePicker' } : field);

  const manuDateField = pwraDateTime(manuDate);
  const rsinspectionDateField = pwraDateTime(rsinspectionDate);
  const castingDateField = pwraDateTime(castingDate);
  const deliveryDateField = pwraDateTime(deliveryDate);
  const arrivalDateField = pwraDateTime(arrivalDate);
  const installDateField = pwraDateTime(installDate);
  const secondCastingDateField = pwraDateTime(secondCastingDate);

  const isCompletedWithTitle = {
    ...isCompleted,
    checkboxTitle: t('STATUS')
  };
  const cateWithOptions = {
    ...cate,
    options: categoryOptions,
    fieldProps: {
      onChange: (e) => {
        if (stepCode !== STEPCODE.ALW10) {
          const wn = document.querySelector('input[name="WorkingNo"]');

          wn.classList.add('Mui-disabled');

          wn.disabled = true;
        }
      }
    }
  };
  const subCateWithOptions = {
    ...subCate,
    options: subCategoryOptions,
    fieldProps: {
      onChange: (e) => {
        if (stepCode === STEPCODE.ALW10) {
          const wn = document.querySelector('input[name="WorkingNo"]');

          wn.classList.add('Mui-disabled');

          wn.disabled = true;
        }
      }
    }
  };

  const disabledSerialNo = {
    ...serialNo,
    fieldProps: {
      disabled: true
    }
  };

  const workingNoWithLimit = {
    ...workingNo,
    fieldProps: {
      type: 'number',
      onChange: (e) => {
        if (e.target.value.length > 4) {
          e.target.value = e.target.value.substring(0, 4);
        }
        return e;
      }
    }
  };

  const blockWithOptions = {
    ...block,
    options: blockOptions,
    fieldProps: {
      onChange: (e) => {
        setSelectedRegion(e.target.value);
      },
      onClear: () => {
        setValue('Floor', '');
        setValue('RoomNo', '');
        setValue('RoomId', '');
      }
    }
  };

  const rsCompanyWithOptions = {
    ...rsCompany,
    id: isAudit ? rsCompany.id : 'RscompanyId',
    options: rsCompanyOptions
  };
  const hingeSupplierWithOptions = {
    ...hingeSupplier,
    id: isAudit ? hingeSupplier.id : 'SupplierId',

    options: supplierOptions
  };

  const concreteGradeWithOptions = {
    ...concreteGrade,
    options: concreteOptions
  };
  const floorWithOptions = {
    ...floorNo,
    options: floorOptions,

    fieldProps: {
      required: !!selectedRegion && !isBatch,
      disabled: !selectedRegion,
      onChange: (e) => {
        setSelectedFloor(e.target.value);
      },
      onClear: () => {
        setValue('RoomNo', '');
        setValue('RoomId', '');
      }
    }
  };
  const unitWithOptions = {
    ...unit,
    // id: isAudit || preview || disposed ? 'RoomNo' : 'RoomId',
    id: isAudit || preview ? 'RoomNo' : 'RoomId',
    // type: isAudit || preview ? 'text' : 'select',
    options: unitOptions,
    fieldProps: {
      required: !!(selectedRegion || selectedFloor) && !isBatch,
      disabled: !selectedRegion || !selectedFloor,
      onChange: (e) => {
        const resultUnitLabel = unitOptions.find((u) => u.value === e.target.value)?.label;
        setSelectedRoom(resultUnitLabel);
      }
    }
  };

  const roomInputConditional =
    selectedRoom === 'NA' || isAudit
      ? {
          ...roomInput,
          fieldProps: {
            onChange: (e) => {
              if (e.target.value.length > 10) {
                e.target.value = e.target.value.substring(0, 10);
              }

              return e;
            },
            disabled: selectedRoom !== 'NA'
          }
        }
      : {};

  switch (stepCode) {
    case STEPCODE.MIC10:
    case STEPCODE.PCF10:
    case STEPCODE.VPB10:
    case STEPCODE.VPK10:
      return [
        cateWithOptions,
        disabledSerialNo,
        workingNoWithLimit,
        concreteGradeWithOptions,
        productNo,
        manuDateField,
        blockWithOptions,
        floorWithOptions,
        unitWithOptions,
        roomInputConditional,
        remark,
        isCompletedWithTitle
        // isCompleted
      ];
    case STEPCODE.MIC20:
    case STEPCODE.PCF20:
    case STEPCODE.VPB20:
    case STEPCODE.VPK20:
      return [rsCompanyWithOptions, rsinspectionDateField, remark, isCompleted];
    case STEPCODE.MIC30:
    case STEPCODE.PCF30:
    case STEPCODE.VPB30:
    case STEPCODE.VPK30:
      return [castingDateField, secondCastingDateField, remark, isCompleted];
    case STEPCODE.MIC35:
    case STEPCODE.PCF35:
      return [internalFinishDate, remark, isCompleted];
    case STEPCODE.VPB35:
    case STEPCODE.VPK35:
      return [waterproofingInstallationDate, remark, isCompleted];
    case STEPCODE.MIC40:
    case STEPCODE.PCF40:
    case STEPCODE.VPB40:
    case STEPCODE.VPK40:
      return [
        deliveryDateField,
        {
          ...licensePlateNo,
          fieldProps: {
            disabled: true
          }
        },
        { ...batchNo, label: t('T_PLATE_NO') },

        // GpsDeviceId,
        remark,
        isCompleted
      ];
    case STEPCODE.MIC50:
    case STEPCODE.PCF50:
    case STEPCODE.VPB50:
    case STEPCODE.VPK50:
      return [arrivalDateField, chipFailureSA, remark, isCompleted];
    case STEPCODE.MIC60:
    case STEPCODE.PCF60:
    case STEPCODE.VPB60:
    case STEPCODE.VPK60:
      return [
        installDateField,
        blockWithOptions,
        floorWithOptions,
        unitWithOptions,
        roomInputConditional,
        chipFailureSI,
        remark,
        isCompleted
      ];
    case STEPCODE.VPB70:
    case STEPCODE.VPK70:
      return [arrivalDateField, chipFailureSA, remark, isCompleted];
    case STEPCODE.VPB80:
    case STEPCODE.VPK80:
      return [
        installDateField,
        blockWithOptions,
        floorWithOptions,
        unitWithOptions,
        roomInputConditional,
        chipFailureSI,
        remark,
        isCompleted
      ];
    case STEPCODE.ALW10: {
      // MTEST Project is not required to fill in the category
      if (project?.ProjCode === 'MTEST') {
        const MTESTSubCateWithOptions = {
          label: t('CATEGORY'),
          id: 'Subcategory',
          type: 'select',
          options: subCategoryOptions,
          fieldProps: {
            onChange: (e) => {
              if (stepCode === STEPCODE.ALW10) {
                const wn = document.querySelector('input[name="WorkingNo"]');

                wn.classList.add('Mui-disabled');

                wn.disabled = true;
              }
            }
          }
        };
        return [
          MTESTSubCateWithOptions,
          // subCateWithOptions,
          disabledSerialNo,
          workingNoWithLimit,
          hingeSupplierWithOptions,
          manuDateField,
          remark,
          isCompleted
        ];
      }

      return [
        cateWithOptions,
        subCateWithOptions,
        disabledSerialNo,
        workingNoWithLimit,
        hingeSupplierWithOptions,
        manuDateField,
        remark,
        isCompleted
      ];
    }

    case STEPCODE.ALW20:
      return [deliveryDateField, batchNo, remark, isCompleted];
    case STEPCODE.ALW30:
      return [arrivalDateField, chipFailureSA, remark, isCompleted];
    case STEPCODE.ALW40:
      return [
        installDateField,
        blockWithOptions,
        floorWithOptions,
        unitWithOptions,
        roomInputConditional,
        chipFailureSI,
        remark,
        isCompleted
      ];
    case STEPCODE.STA10:
      return [cateWithOptions, subCateWithOptions, disabledSerialNo, workingNoWithLimit, manuDateField, remark, isCompleted];
    case STEPCODE.TID10:
    case STEPCODE.MEG10:
      return [cateWithOptions, disabledSerialNo, workingNoWithLimit, manuDateField, remark, isCompleted];
    case STEPCODE.TID20:
    case STEPCODE.MEG20:
    case STEPCODE.STA20:
      return [deliveryDateField, batchNo, remark, isCompleted];
    case STEPCODE.TID30:
    case STEPCODE.MEG30:
    case STEPCODE.STA30:
      return [arrivalDateField, chipFailureSA, remark, isCompleted];
    case STEPCODE.TID40:
    case STEPCODE.MEG40:
    case STEPCODE.STA40:
      return [
        installDateField,
        blockWithOptions,
        floorWithOptions,
        unitWithOptions,
        roomInputConditional,
        chipFailureSI,
        remark,
        isCompleted
      ];

    default:
      return [];
  }
};
